import { styled } from "@mui/material";
import { StyledPopup } from "../Popup.styled";

export const StyledPopupWithoutFooter = styled(StyledPopup)`
  .MuiDialogContent-root {
    padding: 0px;
    margin: 0px;
  }
`;
